import type { HotelPnrRequest } from "@/modules/hotels/interfaces/hotelPnrRequest";
import { useStorage } from "@vueuse/core";
import { defineStore } from "pinia";

export const useHotelRatePayloadStore = defineStore("hotelRatePayload", () => {
  return {
    setPayLoadToLocalStorage(payload: HotelPnrRequest) {
      useStorage("hotelRatePayload", payload);
    },
  };
});
